module.exports = __webpack_public_path__ + "fonts/baronsans-extralight-webfont.2077a6fe.woff2";